import React from 'react';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import './Loading.pcss';

const Loading = () => {
  return (
    <div className="Loading">
      <FormattedMessageWrapper langKey="web.loading.text" />
    </div>
  );
};

export default React.memo(Loading);
